var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconStarBig = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44.028,
  height: 40,
  viewBox: "0 0 44.028 40",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  d: "M631.989,597.647l6.128,11.839a.866.866,0,0,0,.655.454l13.7,1.9a.82.82,0,0,1,.481,1.415l-9.916,9.214a.805.805,0,0,0-.25.734l2.341,13.012a.862.862,0,0,1-1.263.874l-12.256-6.143a.906.906,0,0,0-.811,0l-12.256,6.143a.862.862,0,0,1-1.263-.874l2.341-13.012a.8.8,0,0,0-.249-.734l-9.916-9.214a.82.82,0,0,1,.482-1.415l13.7-1.9a.866.866,0,0,0,.655-.454l6.128-11.839A.891.891,0,0,1,631.989,597.647Z",
  transform: "translate(-609.194 -597.185)",
  fill: "#ffca0e"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconStarBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_star_big.2f82444a.svg";
export { ForwardRef as ReactComponent };